import { useFeatureFlag } from 'providers';
import { promotions } from 'constants/promotions';
import { Wrapper, Cost, StyledLogo, OriginalCost } from './Points.styles';

interface PointsProps {
  points: number;
  originalPoints?: number;
  className?: string;
}

const { isSaleOfferPeriod } = promotions;

const Points = ({ points, originalPoints, className }: PointsProps) => {
  const allowSaleOffers = useFeatureFlag('allowSaleOffers') && isSaleOfferPeriod;
  const isOnSale = allowSaleOffers && originalPoints !== undefined;

  return (
    <Wrapper className={className}>
      {isOnSale && <OriginalCost variant="subtitle1">{originalPoints}</OriginalCost>}
      <Cost highlight={`${isOnSale}`} variant="subtitle1">
        {points}
      </Cost>
      <StyledLogo />
    </Wrapper>
  );
};

export default Points;
